<template>
	<div class="inlist">
		<el-card>
			<div v-for="tab in tabs">
				<el-row>
					<el-col :span="17">
						<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
						<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
					</el-col>
					<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
					<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
					<el-col :span="2" class="rightcol">
						<el-popover placement="bottom-end" width="350" trigger="click">
							<table class="htmltable">
								<tr>
									<td><label>单据编号</label></td>
									<td>
										<el-input type="textarea" rows="3" v-model="searchlist.billid" size="mini"></el-input>
									</td>
								</tr>
								<tr>
									<td><label>供应商</label></td>
									<td>
										<el-select
											ref="crm_c_id"
											v-model="searchlist.crm_c_cname"
											filterable
											remote
											reserve-keyword
											size="mini"
											placeholder="请输入关键词"
											:remote-method="customerinput"
											@change="handleSelect"
											:loading="loading"
										>
											<el-option v-for="item in customerlist" :key="item.cname" :label="item.cname" :value="item.cname"></el-option>
										</el-select>
									</td>
								</tr>
								<tr>
									<td><label>入库时间</label></td>
									<td style="text-align:left;">
										<el-date-picker
											v-model="searchlist.starttime"
											type="date"
											placeholder="选择开始日期"
											size="mini"
											value-format="yyyy-MM-dd"
										></el-date-picker>
									</td>
								</tr>
								<tr>
									<td><label>至</label></td>
									<td>
										<el-date-picker v-model="searchlist.endtime" type="date" placeholder="选择结束日期" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
									</td>
								</tr>
								<tr>
									<td colspan="4" class="bottombtn">
										<el-button @click="GetTabData()" type="warning" size="mini">查询</el-button>
										<el-button @click="ClearSearch(0)" size="mini">清空</el-button>
									</td>
								</tr>
							</table>
							<el-link slot="reference" type="primary">更多筛选</el-link>
						</el-popover>
					</el-col>
				</el-row>
				<el-row style="height:10px;"></el-row>
				<el-row>
					<el-col :span="24">
						<tableui
							style="width:100%;"
							v-loading="loading"
							ref="inlisttable"
							editcell="0"
							:tableData="orderlist"
							:columns="tab.columns"
							@gridhandle="gridhandle"
							:gridheight="gridheight"
							@gridsort="gridsort"
							@checkboxchange="checkboxchange"
							@gridscroll="gridscroll"
						></tableui>
					</el-col>
				</el-row>
			</div>
			<div>
				<el-row>
					<el-col :span="12">
						<span>共 {{count}} 条数据</span>
				    </el-col>
				</el-row>
			</div>
		</el-card>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		handlerbutton
	},
	data() {
		return {
			searchlist: {
				billid: '',
				starttime: '',
				endtime: '',
				crm_c_cname:'',
				crm_c_id:''
			},
			searchbox: '',
			activeTabIndex: 0, //激活的选项卡index
			pickerOptions: '',
			orderlist: [],
			gridheight: (window.innerHeight * 72) / 100 + 'px',
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '仓库管理-入库', //当前操作的功能模块名称
			selectedall: false,
			checkedrow: [],
			count:0,
			customerlist:[],
			divclass:'inlist'
		}; 
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/stockmanager/inlist.scss');
			this.getTabs();
		});
	},
	methods: {
		//获取选项卡
		getTabs() {
			this.$apipost.get.GetTabs({ parentid: 221 }).then(res => {
				this.tabs = res.tabs;
				this.GetTabData();
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				billid: '',
				starttime: '',
				endtime: '',
				crm_c_cname:'',
				crm_c_id:''
			};
			if (type == 1) {
				this.searchbox = '';
			}
		},
		//获取表头方法
		GetTabData() {
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if(e!=undefined){
				var that = this;
				const scrollDistance = e.event.target.scrollHeight -e.e.scrollTop-e.event.target.offsetHeight;
				if (scrollDistance <=82) {
					that.refreshgrid(false);
				}
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.orderlist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				var paraminfo={
					search: this.GetSearchObj(),
					tab:this.tabs[this.activeTabIndex].type,
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					l_mode:this.mode,
					userid:localStorage.getItem('userid')
				}
				// console.log('入库列表',escape(JSON.stringify(paraminfo)));
				// return false;
				this.loading = true;
				this.$apipost.get
					.GetStockInOutList({
						paraminfo:paraminfo
					})
					.then(res => {
						that.loading = false;
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.orderlist=that.orderlist.concat(res.data);
							} else {
								that.orderlist = res.data;
							}
							this.count=res.count;
							that.tabs[this.activeTabIndex].pagecount = res.pagecount;
						}
					});
			}
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			search.billid = search.billid.replace(/\n/g, ',');
			return JSON.stringify(search);
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式 
			console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'add') {
				Utils.$emit('go', { l_url: '/stockmanager/createstockinfo', l_id:e.l_id, l_name:e.l_name,urlparam: {l_tablename:e.l_tablename,handletype:'instock'}});
			}
			if (e.event == 'del') {
				this.DelStockIn();
			}
		},
		gridhandle(e) {
			var that=this;
			this.checkedrow=[];
			if (e.event == 'del') {
				//删除
				this.checkedrow.push(this.orderlist[e.index]);
				this.DelStockIn();
			}
			if(e.event=='detail'){
				Utils.$emit('handleRermove',"单据详情");
				setTimeout(function(){
					Utils.$emit('go', { l_url: '/stockmanager/createstockinfo', l_id:e.l_id, l_name:'单据详情',urlparam: {pkval:that.orderlist[e.index].billid,iscopy:0, l_tablename:e.colattr.l_tablename,isdetail:1,handletype:'instock' }});
				},100);
			}
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var pkval = '';
			var isgo = true;
			var search = {
				id: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					pkval += e.id + ',';
				});
				if (pkval != '') {
					pkval = pkval.substring(0, pkval.length - 1);
					search.id = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选数据', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		//删除入库记录方法1/2
		DelStockIn() {
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				var that = this;
				this.$confirm('确定删除所选记录吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
						var paraminfo = {
							search: searchinfo,
							mode: that.mode,
							tab: that.tabs[that.activeTabIndex].type,
							sort: that.sort,
							userid: localStorage.getItem('userid')
						};
						// console.log('删除',escape(JSON.stringify(paraminfo)));
						// return false;
						this.$tool.loading('正在删除', that.divclass);
						this.$apipost.post.DelStockIn({paraminfo:paraminfo}).then(res => {
							this.$tool.loadingclose();
							if (res.state == '1') {
								this.$tool.message('操作成功', 1);
								that.refreshgrid(true);
							} else {
								if(res.localfilename==undefined)
									this.$tool.message('删除失败', 0);
								else{
									this.$tool.message('删除未完成，请查看下载的详情', 0);
									this.$tool.downfile(that,res.localfilename);
								}
							}
						});
					})
					.catch(() => {});
			}
		},
		//重置筛选
		ResetFilterInfo(){
			this.ClearSearch(1); //先清空筛选条件
			this.refreshgrid(true);
		},
		//选择客户联动
		customerinput(val) {
			var that = this;
			var search = {
				searchbox: val,
				c_type: '供应商,客户及供应商'
			};
			this.$tool.customerlink(this, search, 'page');
		},
		//选中提示选项时
		handleSelect(item) {
			var list = this.customerlist.filter(e => {
				return e.cname == item;
			});
			if (list.length > 0) {
				this.searchlist.crm_c_id = list[0].id;
			}
		}
	}
};
</script>
